export const QUICK_REPLIES_IMG_URL = 'https://cdn.livechat-static.com/api/file/lc/img/default/assets/quick-replies.gif';
export const ANNOUNCEMENT_IMG_URL = 'https://cdn.livechat-static.com/api/file/lc/img/default/assets/announcement.gif';
export const CONTEXT_MENU_IMG_URL = 'https://cdn.livechat-static.com/api/file/lc/img/default/assets/context-menu.gif';
